"use client";
import { Input, InputProps } from "@chakra-ui/react";

export function PlaceSearchInput(props: InputProps) {
  return (
    <Input
      data-testid="search-input"
      aria-autocomplete="list"
      autoComplete="off"
      autoCorrect="off"
      spellCheck="false"
      aria-label="Search: Suggestions appear below"
      maxLength={64}
      _placeholder={{ color: "gray.500" }}
      w="100%"
      h="68px"
      pr="68px"
      pl="4"
      fontWeight="medium"
      outline="0"
      bg="white"
      borderRadius="md"
      placeholder="Enter a zip code, city, or address to generate a report to your nearest city"
      _focusVisible={{
        boxShadow: "none",
        border: "none",
      }}
      {...props}
    />
  );
}
